import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  "aria-live": "polite",
  "aria-atomic": "true",
  class: "z-50 fixed inset-0 flex flex-col items-center px-4 py-6 pointer-events-none"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      name: "fade",
      tag: "div",
      class: "flex flex-col items-center",
      "enter-active-class": "ease-out duration-500",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "ease-in duration-300",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toasts, (toast) => {
          return (_openBlock(), _createBlock(_component_Toast, {
            key: toast.id,
            id: toast.id,
            type: toast.type,
            title: toast.title,
            description: toast.description,
            duration: toast.duration,
            onClose: _ctx.removeToast
          }, null, 8, ["id", "type", "title", "description", "duration", "onClose"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}